import { render, staticRenderFns } from "./update_price.vue?vue&type=template&id=424907c6&"
import script from "./update_price.vue?vue&type=script&lang=js&"
export * from "./update_price.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports